import { apiHost } from '../../../config';
import { put } from '../../requests';
import Teacher from '../../../types/Teacher';

export default async function updateTeacher(
  id: number,
  teacher: Partial<Omit<Teacher, 'id'>>,
) {
  return put(`${apiHost}/api/admin/users/${id}`, teacher);
}
